import * as am5xy from '@amcharts/amcharts5/xy';

export class DatiqAmcharts5ChartXyMiniature {
    private _chart: am5xy.XYChart;

    constructor(chart: am5xy.XYChart) {
        this._chart = chart;
    }

    build(): am5xy.XYChart {
        return this._chart;
    }
}
